/**
 * Shared date helpers + status palettes for the Gantt chart.
 * Extracted from PhaseGanttChart.js during Refactoring Phase 4.
 */

export const parseDate = (str) => {
  if (!str) return null;
  const d = new Date(str + 'T00:00:00');
  return isNaN(d.getTime()) ? null : d;
};

export const daysBetween = (a, b) => Math.round((b - a) / (1000 * 60 * 60 * 24));

export const addDays = (d, n) => {
  const r = new Date(d);
  r.setDate(r.getDate() + n);
  return r;
};

export const formatDateShort = (d) => {
  if (!d) return '';
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

export const toDateStr = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export const STATUS_BAR = {
  Complete: 'bg-emerald-500',
  'In Progress': 'bg-blue-500',
  'Not Started': 'bg-zinc-300',
  Delayed: 'bg-red-500',
};

export const STATUS_DOT = {
  Complete: 'bg-emerald-500',
  'In Progress': 'bg-blue-500',
  'Not Started': 'bg-zinc-400',
  Delayed: 'bg-red-500',
};
